<template>
    <li class="timeline-item" style="padding-bottom: 0.5rem;">
        <template v-if="! contextualization">
            <template v-if="sortable">
                <sortable-handle>
                    <div class="timeline-marker" :class="{'is-primary': event.status == 'published', 'is-grey-light': event.status == 'draft'}"></div>
                </sortable-handle>
            </template>
            <template v-if="! sortable">
                <div class="timeline-marker" :class="{'is-primary': event.status == 'published', 'is-grey-light': event.status == 'draft'}"></div>
            </template>
        </template>
        <template v-if="contextualization">
            <div class="timeline-marker" :class="'is-'+event.timeline.color" v-if="event.status == 'published'"></div>
            <div class="timeline-marker is-grey-light" v-if="event.status == 'draft'"></div>
        </template>
        <div class="timeline-content" style="padding-top: calc(0.85em - 10px); padding-left: calc(2em - 20px); width: 100%; margin-top: 10px;margin-left: 20px;">
            <div class="level" style="margin-bottom: 0;">
                <div class="level-left">
                    <div class="level-item">
                        <router-link :to="{ name: 'events.show', params: {id: event.id}}" style="height: 1.5em; display: inline-flex; align-items: center;">
                            <b :class="{'has-text-primary': event.status == 'published', 'has-text-grey-light': event.status == 'draft'}">{{ event.title }}</b>
                        </router-link>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <span v-if="contextualization === true">
                            <router-link :to="{ name: 'timelines.show', params: { id: event.timeline.id }}">
                                <b-tag :type="'is-'+event.timeline.color" style="margin-left: 20px;">{{ event.timeline.title }}</b-tag>
                            </router-link>
                        </span>
                    </div>
                </div>
            </div>
            <p class="heading">
                <span style="display: inline-block; width: 200px;">
                    <i class="fa fa-calendar"></i>
                    <span>{{ format_date(event.start) }}</span>
                    <span v-if="event.end"> &mdash; </span>
                    <span v-if="event.end">{{ format_date(event.end) }}</span>
                </span>
                <span>
                    <i class="fa fa-files-o"></i>
                    <span>{{ event.medias }}</span>
                </span>
            </p>
            <div>
                <p style="font-style: italic; font-size: 85%;">{{ event.description }}</p>
            </div>
        </div>
    </li>
</template>

<script>
    import format_date from '../../mixins/date';

    export default {

        mixins: [format_date],

        props: ['data', 'contextualization', 'sortable'],
    
        data() {
            return {
                event: this.data,
            }
        },

    }
</script>
<style scoped>
    .timeline-marker.sortable-handle:hover {
        cursor: move;
    }

    .timeline-content {
        background: white;
    }

    .timeline-item.draggable-mirror::before {
        background-color: transparent !important;
    }

    .draggable-mirror .timeline-marker {
        display: none !important;
    }

    .draggable-mirror .timeline-content {
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    }

    .draggable--over {
        background: transparent;
    }

    .draggable--over * {
        background: #a1a1a1 !important;
        color: #a1a1a1 !important;
    }

    .draggable--over .timeline-marker {
        background: #a1a1a1 !important;
        color: #a1a1a1 !important;
    }
</style>